import React, { useEffect } from 'react'
import { get, isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import smoothscroll from 'smoothscroll-polyfill';

// TODO please do not remove that commented icon
// import { ReactComponent as SortIcon } from '../../assets/icons/sort-icon.svg'
import EventList from './EventList'
import Pagination from '../Pagination/Pagination'
import usePrevious from '../../hooks/usePrevious'
import useScrollPosition from '../../hooks/useScrollPosition'

import { setScreenScrollOffset } from '../../store/AppState/actions'
import { setCurrentPaginationPage } from '../../store/AppState/actions'

import { getScreenScrollOffset } from '../../store/AppState/selector'
import { getCurrentPaginationPage } from '../../store/AppState/selector'

const SuitesEvents = ({
  currentVenueTimezone,
  currentVenueUuid,
  history,
  loadSalesEvents,
  loadSalesEventTypes,
  location,
  paginator,
  showPreviousEvents,
  updateShowPreviousEvents,
}) => {
  const currentScreen = showPreviousEvents ? 'eventsPrevious' : 'eventsUpcoming'
  const previousCurrentVenueUuid = usePrevious(currentVenueUuid)
  const offsetToScroll = useSelector((state) => getScreenScrollOffset(state, currentScreen))
  const currentPersistedPaginationPage = useSelector((state) => getCurrentPaginationPage(state, currentScreen))
  const scrollPosition = useScrollPosition()
  const dispatch = useDispatch()

  const setEventsScrollPosition = () => {
    dispatch(setScreenScrollOffset({ screen: currentScreen, offset: scrollPosition }))
  }

  useEffect(() => {
    smoothscroll.polyfill()
    window.scrollTo({top: offsetToScroll})
    // eslint-disable-next-line
  }, [currentScreen])

  useEffect(() => {
    if (currentVenueUuid === previousCurrentVenueUuid) return

    if (!isEmpty(currentVenueUuid)) {
      loadSalesEvents(currentVenueUuid)
    }
  }, [loadSalesEvents, currentVenueUuid, previousCurrentVenueUuid])

  useEffect(() => {
    if (currentVenueUuid === previousCurrentVenueUuid) return

    loadSalesEventTypes()
  }, [loadSalesEventTypes, currentVenueUuid, previousCurrentVenueUuid])

  const { result, updatePage } = paginator
  const selectedEventId = get(location, 'state.selectedEventId')

  const handlePersistPaginationPage = page => {
    dispatch(setCurrentPaginationPage({ screen: currentScreen, page }))
  }

  return (
    <div className="events">
      <div className="header">
        <ul className="header__previous-events-switch">
          <li
            className={!showPreviousEvents ? '-active' : null}
            onClick={() => {
              updateShowPreviousEvents(false)
              updatePage(0)
            }}>
            Upcoming</li>
          <li
            className={showPreviousEvents ? '-active' : null}
            onClick={() => {
              updateShowPreviousEvents(true)
              updatePage(0)
            }}>
            Previous</li>
        </ul>
        <ul className="header__menu">
          <li>
            Event
            {/* // TODO confirm what type of sort by clicking that icon */}
            {/* <SortIcon /> */}
          </li>
          <li>Type</li>
        </ul>
      </div>
      <EventList
        currentEventId={selectedEventId}
        currentVenueTimezone={currentVenueTimezone}
        data={result}
        history={history}
        setEventsScrollPosition={setEventsScrollPosition}
      />
      <div className="footer">
        <Pagination
          currentPersistedPaginationPage={currentPersistedPaginationPage}
          handlePersistPaginationPage={handlePersistPaginationPage}
          paginator={paginator}
          key={showPreviousEvents}
         />
      </div>
    </div>
  )
}

SuitesEvents.defaultProps = {
  events: [],
  loadSalesEvents: () => {},
  nextPage: () => {},
  previousPage: () => {},
  updateOffset: () => {},
  updateShowPreviousEvents: () => {},
}

SuitesEvents.propTypes = {
  events: PropTypes.arrayOf(PropTypes.object),
  loadSalesEvents: PropTypes.func,
  nextPage: PropTypes.func,
  previousPage: PropTypes.func,
  updateOffset: PropTypes.func,
  updateShowPreviousEvents: PropTypes.func,
}

export default SuitesEvents
